import React from 'react';

import { Note } from '@components/ui/Note';

import type { AuthFormNotificationProperties } from './AuthFormNotification.types';

/**
 * Unified notification for auth forms.
 * Renders success or error Note based on state.
 * Replaces 7 page-specific FormNotification components.
 */
export const AuthFormNotification: React.FC<AuthFormNotificationProperties> = ({
  isError,
  isSuccess,
  errorTitle = 'Ошибка',
  errorMessage,
  successTitle = 'Успешно',
  successMessage,
  dataTest,
  sx,
}) => {
  if (!isError && !isSuccess) return;

  if (isError) {
    return (
      <Note
        dataTest={dataTest ? `${dataTest}_failure` : 'auth_note_failure'}
        variant='error'
        noteTitle={errorTitle}
        sx={sx}
      >
        {errorMessage ?? 'Неизвестная ошибка'}
      </Note>
    );
  }

  return (
    <Note
      dataTest={dataTest ? `${dataTest}_success` : 'auth_note_success'}
      variant='success'
      noteTitle={successTitle}
      sx={sx}
    >
      {successMessage}
    </Note>
  );
};
